import React from "react"
import { Icon } from "@chakra-ui/react"

export function Logo() {
  return (
    <Icon viewBox="0 0 150 150" h="36px" w="36px">
      <path
        fill="currentColor"
        d="M145.7,68.6c-2.4,0-4.3,1.9-4.3,4.2v4.3c0,2.3,1.9,4.2,4.3,4.2c2,0,4.3-5.2,4.3-6.5 C150,73.7,147.6,68.6,145.7,68.6z"
      />
      <path
        fill="currentColor"
        d="M137.7,77.2v-4.3c0-0.4,0-0.8,0.1-1.2c-1.3-0.4-2.9-0.7-4.7-0.7c-5.1,0-8.8,2.1-8.8,4c0,1.9,3.8,4,8.8,4 c1.7,0,3.3-0.3,4.7-0.7C137.7,77.9,137.7,77.6,137.7,77.2z"
      />
      <path
        fill="currentColor"
        d="M124.7,69.4c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.3-0.1,0.4-0.2L101.4,13c-1.7-4-3-4.5-5.2-4.5 c-0.4,0-1,0.4-1.6,1.1c-1.6,1.9-2.8,5.8-2.2,8.9l14.7,50.9h14H124.7z"
      />
      <path
        fill="currentColor"
        d="M124.7,80.5c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0.1,0.3,0.1,0.4,0.2l-24.2,55.9c-1.7,4-3,4.5-5.2,4.5 c-0.4,0-1-0.4-1.6-1.1c-1.6-1.9-2.8-5.8-2.2-8.9l14.7-50.9h14H124.7z"
      />

      <path
        fill="currentColor"
        d="M133.1,67.4c0.1,0,0.2,0,0.3,0V4.2c0-2.3-1.9-4.2-4.3-4.2c-1.5,0-3.2,0.6-4.4,4.7l-8.5,33.5l12.9,29.7 C130.4,67.6,131.7,67.4,133.1,67.4z"
      />

      <path
        fill="currentColor"
        d="M133.1,82.6c0.1,0,0.2,0,0.3,0v63.2c0,2.3-1.9,4.2-4.3,4.2c-1.5,0-3.2-0.6-4.4-4.7l-8.5-33.5l12.9-29.7 C130.4,82.4,131.7,82.6,133.1,82.6z"
      />

      <path
        fill="currentColor"
        d="M120.6,75c0-0.7,0.2-1.4,0.4-2.1H2.2c-1.2,0-2.2,0.9-2.2,2c0,1.1,1,2,2.2,2H121 C120.8,76.3,120.6,75.7,120.6,75z"
      />
    </Icon>
  )
}
